<template>
    <v-container class="max-container">
        <!--RATING-SCREEN-->
            <!--NOTE-IMPROVE-->
                <v-row class="noteimprove__row">
                    <!--NOTE-->
                        <v-col class="noteimprove__row__colnote no-pd-l" :cols=" dynamicCol ? '12 ' : '6' ">
                            <v-row class="note__row">
                                <v-col class="note__row__coltitle" :cols=" dynamicCol ? '4' : '6' ">
                                    <v-row class="justify-center">
                                        <v-col class="no-pd" cols="6">
                                            <v-skeleton-loader class="note__row__coltitle__title" type="image"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col class="note__row__colgrades no-pd-t no-pd-r" cols="6">
                                    <v-row class="note__row__colgrades__row">
                                        <v-col class="no-pd-t  d-flex flex-row"  cols="12" >
                                            <v-skeleton-loader v-for="n in 5" :key="n"  class="note__row__colgrades__grades" type="image"/>
                                        </v-col>                                       
                                    </v-row>
                                    <v-row class="note__row__colgrades__row">
                                        <v-col class="no-pd-t d-flex flex-row" cols="12" >
                                            <v-skeleton-loader v-for="n in 5" :key="n"  class="note__row__colgrades__grades" type="image"/>
                                        </v-col>                                       
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    <!--END-NOTE-->
                    <!--IMPROVE-->
                        <v-col class="noteimprove__row__colimprove" :cols=" dynamicCol ? '12 ' : '6' ">
                            <v-row class="improve__row">
                                <v-col class="improve__row__coltitle" cols="12">
                                    <v-row class="justify-center">
                                        <v-col class="no-pd " cols="6">
                                            <v-skeleton-loader class="improve__row__coltitle__title" type="image"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col class="improve__row__colimprove no-pd-l no-pd-t" :cols=" dynamicCol ? '11' : '12'">                                
                                    <v-row class="improve__row__colimprove__row">
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " cols="3">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " cols="3">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " :cols=" dynamicCol ? '3' : '2' ">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " :cols=" dynamicCol ? '3' : '2' ">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " :cols=" dynamicCol ? '3' : '2' ">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                        <v-col class="improve__row__colimprove__row__col  no-pd-l no-pd-t " cols="3">
                                            <v-skeleton-loader class="improve__row__colimprove__row__col__improve" type="image"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    <!--END-IMPROVE-->
                </v-row>
            <!--END-NOTE-IMPROVE-->
            <!--COMMENT-->
                <v-row class="row__comment">
                    <v-row class="row__comment__titlerow">
                        <v-col class="row__comment__titlerow__col" cols="3"> 
                            <v-skeleton-loader class="row__comment__titlerow__col__title" type="image"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-skeleton-loader class="row__comment__textarea__coltextarea__textarea" type="image"/>
                        </v-col>
                    </v-row>
                    <v-row class="row__coment__btnrow">
                        <v-col class="row__btn__colbtn" cols="2">
                            <v-skeleton-loader class="row__btn__colbtn__btn" type="image"/>
                        </v-col>
                    </v-row>
                </v-row>
            <!--END-COMMENT-->
        <!--END-RATING-SCREEN--->
    </v-container>
</template>

<script>
export default {
    name: 'ratingLoader',
    data: () => ({
        dynamicCol: false
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            ( window.innerWidth < 960 )? this.dynamicCol = true : this.dynamicCol = false;

        },
    }
}
</script>

<style scoped>
/*RESPONSIVIT*/
    @media(max-width: 959px) {
        .noteimprove__row {
            flex-direction: column !important;
        }
        .improve__row{
            align-items: center;
        }
    }
    @media(max-width: 600px) {
        .note__row__colgrades {
            min-width: 266px;
        }
        .note__row__coltitle {
            min-width: 266px;
        }
    }
/*END-RESPONSIVIT*/
/*NOTE-IMPROVE*/
    .noteimprove__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
/*END-NOTE-IMPROVE*/
/*NOTE*/
    .note__row {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        align-content: center;
    }
    .note__row__coltitle__title {
        height: 20px;
        border-radius: 8px;
    }
    .note__row__colgrades__grades {
        height: 37px;
        width: 34px;
        border-radius: 18px;
        margin-right: 12px;
    }
    .note__row__colgrades__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
/*END-NOTE*/
/*IMRPOVE*/
    .improve__row {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .improve__row__coltitle__title {
        height: 20px;
        border-radius: 8px;
    }
    .improve__row__colimprove__row__col__improve {
        height: 38px;
        border-radius: 22px;
    }
    .improve__row__colimprove__row__col {
        width: 50px ;
    }
/*END-IMPROVE*/
/*COMMENT*/
    .row__comment {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .row__comment__titlerow {
        justify-content: center;
    }
    .row__comment__titlerow__col__title {
        height: 20px;
        border-radius: 8px;
        margin-top: 15px;
    }
    .row__comment__textarea__coltextarea__textarea {
        height: 150px;
        margin-top: 10px;
    }
    .row__comment__titlerow__col {
        min-width: 268px;
    }
    .row__btn__colbtn {
        min-width: 169px;
    }
    .row__btn__colbtn__btn {
        height: 34px;
        border-radius: 16px;
        margin-top: 36px;
    }
    .row__coment__btnrow {
        justify-content: center;
    }
/*END-COMMENT*/
</style>